import React, { useEffect, useRef, useState } from 'react';
import NFTList from './NFTList';
import '../styles/inventory.css';
import logoutImage from '../assets/images/inventory/Btn_Close.png';
import RInvenImage from '../assets/images/inventory/Panel_R.png';
import LInvenImage from '../assets/images/inventory/Panel_L.png';
import centerImage from '../assets/images/inventory/ChangeIcon.png';
import loadingIcon from '../assets/images/loading.png'; // Loading icon added

const InventoryPage = ({
  account,
  inventoryNFTs,
  walletNFTs,
  loadingInventory,
  loadingWallet,
  transferring,
  handleLogout,
  connectWallet,
  getBackNFT,
  transferNFT,
  INVENTORY_ADDRESS,
  refreshNFTs,
}) => {
  const intervalRef = useRef(null);
  const [localLoading, setLocalLoading] = useState(false);

  // Function to start or restart the 15-second interval
  const startInterval = () => {
    clearInterval(intervalRef.current); // Clear existing interval if any
    intervalRef.current = setInterval(() => {
      refreshNFTs();
    }, 15000);
  };

  // Start the 15-second interval on component mount
  useEffect(() => {
    startInterval(); // Start 15-second interval on mount

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, [refreshNFTs]);

  // Handle 2-second delay refresh after transfer completion
  useEffect(() => {
    if (!transferring) {
      if (localLoading) {
        // 로딩 상태가 끝났으므로 해제
        const timeout2 = setTimeout(() => {
          refreshNFTs(); // Refresh after 2 seconds
          setLocalLoading(false); // Remove local loading state
          startInterval(); // Restart the 15-second interval
        }, 2000);
      }
      return;
    }

    // Set local loading to true for immediate feedback
    setLocalLoading(true);

    const timeout = setTimeout(() => {
      refreshNFTs(); // Refresh after 2 seconds
      setLocalLoading(false); // Remove local loading state
      startInterval(); // Restart the 15-second interval
    }, 2000);

    return () => clearTimeout(timeout); // Cleanup timeout on dependency change
  }, [transferring, refreshNFTs, localLoading]);

  // Combine global and local loading states
  const isLoading = loadingInventory || loadingWallet || transferring || localLoading;

  return (
    <div className="inventory-background">
      {isLoading && (
        <div className="inventory-loadingOverlay">
          <p>Loading data...<br />Please wait a moment!</p>
          <img src={loadingIcon} alt="Loading icon" />
        </div>
      )}
      <div className="inventory-container">
        {/* Header section */}
        <div className="inventory-header">
          <button className="inventory-logoutButton" onClick={handleLogout}>
            <img src={logoutImage} alt="Logout" />
          </button>
        </div>

        {!account ? (
          <button className="inventory-connectButton" onClick={connectWallet}>
            Connect to MetaMask
          </button>
        ) : (
          <div className="inventory-layout">
            {/* Left inventory */}
            <div className="inventory-section1">
              <img
                src={LInvenImage}
                alt="Wallet Inventory"
                className="inventory-backgroundImage"
              />
              <div className="inventory-nftListContainer">
                <NFTList
                  nfts={walletNFTs}
                  onTransfer={(tokenId) =>
                    transferNFT(tokenId, INVENTORY_ADDRESS)
                  }
                  toAddress={INVENTORY_ADDRESS}
                  actionText="Move to ADENA WORLD"
                />
              </div>
            </div>

            {/* Center image */}
            <div className="inventory-centerImage">
              <img src={centerImage} alt="Center image" />
            </div>

            {/* Right inventory */}
            <div className="inventory-section2">
              <img
                src={RInvenImage}
                alt="Server Inventory"
                className="inventory-backgroundImage"
              />
              <div className="inventory-nftListContainer">
                <NFTList
                  nfts={inventoryNFTs}
                  onTransfer={(tokenId) => getBackNFT(tokenId)}
                  toAddress={account}
                  actionText="Recover to Wallet"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryPage;